/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { RANGS_PARENTS_MARIAGE } from '@/constants';

import validationInformationsNaissance from '../validationInformationsNaissance';

/**
 * Validation d'une étape « parents d'un conjoint » d'un acte de mariage.
 *
 * Chaque parent est validé via la validation réutilisable de l'état civil ; un
 * parent déclaré décédé (`filiationInconnueParent{rang}`) n'est pas contrôlé. La
 * date de naissance du conjoint concerné sert au contrôle « parent né avant son
 * enfant ».
 *
 * ⚠️ Les rangs dans `data` sont 1-2 pour le premier conjoint et 3-4 pour le
 * second (cf. `constants/parentsMariage`), alors que l'écran affiche
 * « Parent 1 » / « Parent 2 » dans les deux cas. Les clés d'erreur suivent le
 * RANG, parce que c'est lui que le `ParentForm` de la lib utilise pour nommer
 * ses champs.
 *
 * ⚠️ L'état matrimonial du couple de parents n'est pas contrôlé : il est
 * optionnel, et 610 actes du fonds repris n'en portent aucun.
 *
 * @param data            Racine de `data` (les parents y sont à plat)
 * @param numeroConjoint  1 ou 2 : de quel conjoint il s'agit
 */
const validationStepParentsMariage = (
  data: Record<string, any>,
  numeroConjoint: 1 | 2,
) => {
  const rangs = RANGS_PARENTS_MARIAGE[`conjoint${numeroConjoint}`];
  const conjoint = data?.[`conjoint${numeroConjoint}`] ?? {};

  /** Date de naissance du conjoint, pour le contrôle « parent né avant ». */
  const dateNaissanceEnfant = {
    anneeNaissance: conjoint?.anneeNaissance,
    moisNaissance: conjoint?.moisNaissance,
    jourNaissance: conjoint?.jourNaissance,
  };

  return _.pickBy(
    _.fromPairs(
      rangs.map((rang) => [
        `parent${rang}`,
        validationInformationsNaissance(
          data?.[`parent${rang}`] ?? {},
          true,
          Boolean(data?.[`filiationInconnueParent${rang}`]),
          dateNaissanceEnfant,
        ),
      ]),
    ),
    (erreursParent) => !_.isEmpty(erreursParent),
  );
};

export default validationStepParentsMariage;
